import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import {
  DELETE_TYPE,
  // GETALLACTIVEWITHFILTER_TYPE,
  GETALL_TYPE,
  GETBYGUID_TYPE,
} from "../../../_contstants/common";

export const getAllHealthIssues = createAsyncThunk(
  "getAllHealthIssue/ManageHealthIssue",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageHealthIssues`,
        {
          Name: "",
          OperationType: GETALL_TYPE,
        }
      );
      if (response.data.Status === 200) {
        return response.data?.Data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      console.error("Error Fetching Health Issues:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createHealthIssue = createAsyncThunk(
  "createHealthIssue/ManageHealthIssue",
  async (HealthIssueData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageHealthIssues`,
        HealthIssueData
      );
      if (response.data.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Inserting Health Issue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateHealthIssue = createAsyncThunk(
  "updateHealthIssue/ManageHealthIssue",
  async (HealthIssueData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageHealthIssues`,
        HealthIssueData
      );
      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Health Issue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteHealthIssue = createAsyncThunk(
  "deleteHealthIssue/ManageHealthIssue",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageHealthIssues`,
        {
          HealthIssuesGUID: ID,
          OperationType: DELETE_TYPE,
        }
      );
      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Health Issue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHealthIssueById = createAsyncThunk(
  "getHealthIssueById/ManageHealthIssue",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageHealthIssues`,
        {
          HealthIssuesGUID: ID,
          OperationType: GETBYGUID_TYPE,
        }
      );
      const result = response.data?.Data[0] as any;
      return {
        ID: result?.ID,
        HealthIssuesGUID: result?.HealthIssuesGUID,
        Name: result?.Name,
        IsActive: result?.IsActive === true ? 1 : 2,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Health Issue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveHealthIssue = createAsyncThunk(
  "Master/ManageHealthIssue",
  async (HealthIssueData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageHealthIssues`,
        HealthIssueData
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Health Issue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const activeInactiveHealthIssue = createAsyncThunk(
  "HealthIssueActiveInactive/ManageHealthIssue",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Master/ManageHealthIssues`,
        formData
      );
      if (response.data.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Health Issue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
